import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';


@Component({ standalone: false,
  selector: 'app-table-skeleton',
  templateUrl: './table-skeleton.component.html',

  styleUrls: []
})
export class TableSkeletonComponent implements OnInit {
  products: any[] | undefined;

  @Input() columns: number = 2;
  @Input() rows: number = 5;

  ngOnInit() {
    this.products = Array.from({ length: this.rows }).map((_, i) => `Item #${i}`);
  }
}
